import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './Login.css';
import './_Buttons.css';
import './_Input.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        try {
            await forgotPassword(email);
            setMessage('A password reset link has been sent to your email.');
            setError('');
        } catch (error) {
            setError(mapErrorMessage(error.message));
            setMessage('');
        }
    };

    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
        </div>
        <div className="login-container">
            <form onSubmit={handleForgotPassword} className="login-form">
                {message && <p className="message">{message}</p>}
                {error && <p className="error">{error}</p>}
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">Send Reset Link</button>
                <Link to="/login" className="register-link">
                    Go back to login
                </Link>
            </form>
        </div>
        </div>
    );
};

export default ForgotPassword;
